import React from "react";
import "./privacy.css";
import InnerBanner from "../components/InnerBanner";
import serviceBg from "../assets/FFO+.jpeg";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-wrapper">
      <div className="privacy-container">

        {/* ✅ Banner spacing handled via CSS */}
        <div className="banner-spacing">
          <InnerBanner title="Privacy Policy" bgImage={serviceBg} />
        </div>

        <h1 className="privacy-title">
          🔒 Privacy Policy – Servizy
        </h1>

        <p><strong>Effective Date:</strong> 26 March 2026</p>

        <p>
          Servizy respects your privacy and ensures your personal data is handled securely.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>Name, phone number, address (for doorstep service)</li>
          <li>Device details (model, issue, serial/IMEI if required)</li>
        </ul>

        <h2>2. How We Use Information</h2>
        <ul>
          <li>To schedule and complete repair services</li>
          <li>To communicate service updates and support</li>
          <li>To maintain service records</li>
        </ul>

        <h2>3. Data Protection</h2>
        <ul>
          <li>Your data is kept confidential and not sold or shared with third parties except as required by law.</li>
        </ul>

        <h2>4. Device Data Disclaimer</h2>
        <ul>
          <li>Customers are advised to backup their data before service.</li>
          <li>Servizy is not responsible for data loss during repair.</li>
        </ul>

        <h2>5. Third-Party Links</h2>
        <ul>
          <li>Servizy is not responsible for external websites linked from our platform.</li>
        </ul>

        <h2>6. Updates to Policy</h2>
        <ul>
          <li>Policies may be updated periodically. Changes will be reflected with a revised date.</li>
        </ul>

        <h2>7. Contact Information</h2>
        <p>For queries or concerns:</p>
        <p>
          📞 99900 99900 <br />
          📍 Rajajinagar, Bengaluru
        </p>

      </div>
    </div>
  );
};

export default PrivacyPolicy;